export const Full = 'Полный';
export const KeyMoments = 'Ключевые моменты';
export const Extended = 'Голы';


/** WEBPACK FOOTER **
 ** ./src/constants/GameViewMode.js
 **/